import React from 'react'

import { Badge } from '../../../../components/ui'
import { cn } from '../../../../shared/lib/cn'
import type { ContractExtractionCitation } from '../../types'

export function formatCitationField(field: string): string {
  return field
    .replace(/\[(\d+)\]/g, ' $1')
    .split('_')
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}

function isSameCitation(left?: ContractExtractionCitation, right?: ContractExtractionCitation): boolean {
  if (!left || !right) return false
  return left.field === right.field && left.page === right.page && left.snippet === right.snippet
}

export function ExtractionCitations({
  citations,
  activeCitation,
  onCitationSelect,
}: {
  citations: ContractExtractionCitation[]
  activeCitation?: ContractExtractionCitation
  onCitationSelect?: (citation: ContractExtractionCitation) => void
}) {
  if (!citations.length) return null

  return (
    <div className="mt-5 rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-dark-border dark:bg-dark-bg">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="text-sm font-semibold text-charcoal dark:text-gray-100">Extraction citations</h3>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Source snippets found in the SOW PDF for the parsed fields.
          </p>
        </div>
        <Badge variant="secondary" className="rounded-md">{citations.length} cited</Badge>
      </div>
      <div className="mt-3 grid gap-3">
        {citations.map((citation, index) => (
          <button
            type="button"
            key={`${citation.field}-${citation.page || 'page'}-${index}`}
            onClick={() => onCitationSelect?.(citation)}
            className={cn(
              'rounded-md border bg-white p-3 text-left transition dark:bg-dark-surface',
              isSameCitation(activeCitation, citation)
                ? 'border-eliza-red shadow-sm ring-2 ring-eliza-red/20 dark:border-eliza-red'
                : 'border-gray-200 hover:border-gray-300 dark:border-dark-border',
            )}
          >
            <div className="flex flex-wrap items-center gap-2">
              <Badge variant="default" className="rounded-md">{formatCitationField(citation.field)}</Badge>
              <span className="text-xs font-medium text-gray-500 dark:text-gray-400">
                {citation.page ? `Page ${citation.page}` : 'PDF'}
              </span>
            </div>
            <p className="mt-2 text-xs leading-5 text-gray-600 dark:text-gray-300">{citation.snippet}</p>
          </button>
        ))}
      </div>
    </div>
  )
}

